import script from "./CategorySelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategorySelect.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__